import Breadcrumb, { Section, Divider } from './Breadcrumb';
import GenericRender from './GenericRender';
export type { BreadcrumbItem } from './Breadcrumb';
export { Section, Divider, GenericRender };
export default Breadcrumb;
